export default __webpack_public_path__ + "static/krasnoyarsk-1-e52e80ea4edf7fd472a643593d5bb574.jpg";